// src/constants.ts
var LEFT = "left";
var RIGHT = "right";
var MIDDLE = "middle";
var SCALE_SMALL = "small";
export { LEFT, RIGHT, MIDDLE, SCALE_SMALL };